function debounce(func, delay) {let timeoutId; return function (...args) {const context = this; clearTimeout(timeoutId);timeoutId = setTimeout(() => { func.apply(context, args) }, delay)}}
// ------------ Cart Var Edit start -------------------
function showEditVar(i){
    let popup = i.querySelector('.ctm_var_edit--popup');
    popup.classList.add('ctm_var_edit--popup--active');
    setTimeout(() => { popup.classList.add('ctm_var_edit--popup--active_animation') }, 100);
}
function hideEditVar(i = false){
    let popup = document.querySelector('.ctm_var_edit--popup--active');
    if(i){ popup = i.querySelector('.ctm_var_edit--popup--active') }
    popup?.classList.remove('ctm_var_edit--popup--active_animation');
    setTimeout(() => { popup?.classList.remove('ctm_var_edit--popup--active') }, 250);
}
function varChangeStart(item){
    let i = item.querySelector('.ctm_var_edit--popup_wrapper');
    let curr_qty = i.getAttribute('data-cart-var-qty');
    let new_var = i.getAttribute('data-sel-var-id');
    let updates = {};
    updates[new_var] = curr_qty;
    i.querySelector('.ctm_var-edit--loader').classList.add('ctm_var-edit--loader--active');
    fetch(window.Shopify.routes.root + "cart/update.js", { method: "POST",headers: { "Content-Type": "application/json"},body: JSON.stringify({ updates }) })
    // .then( () => updateCartDrawerContents() )
    .then( () => {
        let cart_qty_btn = item.querySelector('.\\#cart-item-quantity-controls .\\#cart-item-quantity-controls-item');
        if(cart_qty_btn){ cart_qty_btn.setAttribute('set-value','0'); cart_qty_btn.click(); }
        else{ let it_em = item.querySelector('.\\#cart-drawer-product-qty-button.\\@type\\:minus'); it_em.setAttribute('set-value','0'); it_em.click(); }
        hideEditVar(item);
        i.querySelector('.ctm_var-edit--loader').classList.remove('ctm_var-edit--loader--active');
    })
    .catch((error) => { console.error("Error:", error) });
}
function updateSelectedValues(selectedValues) {
    let resultString = "";
    for (let key in selectedValues) { if (selectedValues.hasOwnProperty(key)) { resultString += selectedValues[key] + "  "; }}
    const selectElement = document.querySelector('.cus_hidden_select');
    if (selectElement) {
        const options = selectElement.querySelectorAll('option');
        options.forEach((option) => {
            let label = option.label.replace(/\//g, "").trim();
            if (resultString.toString().trim() === label.toString()) {
                let optionValue = option.value; cusValSel = optionValue;
                let valPopup = document.querySelector('.ctm_var_edit--popup_wrapper');
                valPopup.setAttribute('data-sel-var-id', optionValue);
            } 
        });
    } else { console.log("Select element with class 'cus_hidden_select' not found."); }
}
function updateCartWithId(item){
    const selectedValues = {};const selectElements = item.querySelectorAll('.cus_option_select');
    selectElements.forEach(select => { const selectedOption = select.options[select.selectedIndex];selectedValues[select.name] = selectedOption ? selectedOption.label : null; });
    selectElements.forEach(select => { select.addEventListener('change', function () {
        const selectedOption = select.options[select.selectedIndex];selectedValues[select.name] = selectedOption ? selectedOption.label : null;updateSelectedValues(selectedValues);
    })});
}
// ------------ Cart Var Edit end-------------------





// Wheel & Pipe Addon -- START
function addOnItemIsChecked(item){
    
    let item_parent = item.closest('.wheels_pipes_addon--item');
    if(item_parent.classList.contains('w_p_a--item_checkbox--active')){ item_parent.classList.remove('w_p_a--item_checkbox--active') }
    else{ item_parent.classList.add('w_p_a--item_checkbox--active') }
    
    let parent_wrapper = item_parent.closest('.wheels_pipes_addon--wrapper');
    let isActive = parent_wrapper.querySelectorAll('.w_p_a--item_checkbox--active');

    if(isActive.length > 0){
        parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')
        ? '' : parent_wrapper.classList.add('wheels_pipes_addon--wrapper--atc_active');
    }else{
        parent_wrapper.classList.contains('wheels_pipes_addon--wrapper--atc_active')
        ? parent_wrapper.classList.remove('wheels_pipes_addon--wrapper--atc_active')
        : '';
    }

    updateAddOnItemPrice();
}
function addOnItemQtyUpdate(item, qty = 0){
    let prd_info_parent = item.closest('.\\#product-meta');
    let qty_span = prd_info_parent.querySelectorAll('.w_p_a--item_qty span');

    if(qty_span.length > 0){
        if(parseInt(item.value) > 0 || qty > 0){ 
            if(qty > 0){ qty_span.forEach( i => i.innerHTML = qty ) }
            else{ qty_span.forEach( i => i.innerHTML = item.value ) }
        }
        else{ qty_span.forEach( i => i.innerHTML = 1 ) }
        
        updateAddOnItemPrice();
    }
}
function updateAddOnItemPrice(){
    let wheel_qty = document.getElementById('wheels--item-qty');
    let pipe_qty = document.getElementById('pipes--item-qty');
    let wheel_price = document.getElementById('wheels--item-price');
    let pipe_price = document.getElementById('pipes--item-price');
    // let prd_price = document.querySelector('.\\#product-meta .\\#price .\\@regular').dataset.price;

    let wheel_final_price = (parseInt(wheel_qty.innerHTML) * parseInt(wheel_price.dataset.price)) / 100;
    let pipe_final_price = (parseInt(pipe_qty.innerHTML) * parseInt(pipe_price.dataset.price)) / 100;
    // let prd_final_price = (parseInt(prd_price) * parseInt(pipe_price.dataset.price)) / 100;
    
    let curr_code = pipe_qty.closest('.wheels_pipes_addon--item_list').getAttribute('data-cur-code');
    // let total_price = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheel_pipes_total_price');
    let total_price = pipe_qty.closest('.wheels_pipes_addon').querySelector('.wheels_pipes_addon--total_price span');
    let total;
    
    wheel_price.innerHTML = `${curr_code} ${wheel_final_price.toFixed(2)}`;
    pipe_price.innerHTML = `${curr_code} ${pipe_final_price.toFixed(2)}`;
    
    if(wheel_price.closest('.w_p_a--item_checkbox--active') 
        && pipe_price.closest('.w_p_a--item_checkbox--active')){
        total = wheel_final_price + pipe_final_price;
    }else if(wheel_price.closest('.w_p_a--item_checkbox--active')){ total = wheel_final_price }
    else if(pipe_price.closest('.w_p_a--item_checkbox--active')){ total = pipe_final_price }
    else{ total = false }

    // console.log('total', total);    
    if(total){ total_price.innerHTML = `${curr_code} ${total.toFixed(2)}` }
    else{ total_price.innerHTML = `` }
}
function addOnItemATCClick(item){
    
    let parent = item.closest('.wheels_pipes_addon--wrapper');
    let isAddOn = parent.querySelectorAll('.w_p_a--item_checkbox--active');

    if(isAddOn.length > 0){

        let parrr = item.closest('.wheels_pipes_addon--wrapper');
        parrr.classList.add('w_p_a--atc_loader_active');        

        let formData = { items: [] };
        isAddOn.forEach( a => {
            let id = parseInt(a.getAttribute('data-id'));
            let qty = parseInt(a.querySelector('.w_p_a--item_qty span').innerHTML);
            formData.items.push({ id: id, quantity: qty });
        })
        
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        })
        .then(() => {
            let grand_parent = item.closest('.\\#product-meta');
            grand_parent.querySelector('button.\\#button[type="submit"]').click();
            parrr.classList.remove('w_p_a--atc_loader_active');
        })
        .catch((error) => { console.error("Error:", error) });
    }else{ console.log('NO ADD-ONs SELECTED') }
    
}
function updateAddOnitemVariant(item){
    let grand_parent = item.closest('.\\#product-meta');
    let parent = item.closest('product-variant-selector');
    let var_val = parseInt(parent.querySelector(`[tier_val="true"] h5 span`).innerHTML);
    let pipe_json = JSON.parse(grand_parent.querySelector('[data-pipes-var-json]').innerHTML);

    if(pipe_json){
        let pipe_varr = pipe_json.find(p => p.title.includes(var_val));
        let pipe_item = grand_parent.querySelector('[data-pipes-var-json]').closest('.wheels_pipes_addon--item');
    
        pipe_item.setAttribute('data-id', pipe_varr.id);
        pipe_item.querySelector('.pipe_var_title').innerHTML = pipe_varr.title;
        pipe_item.querySelector('.w_p_a--item_price span').setAttribute('data-price', pipe_varr.price);
    
        updateAddOnItemPrice();
    }

}
// Wheel & Pipe Addon -- END

document.addEventListener('click', (e) => {
    let item = e.target;

    if(item.closest('.ctm_var_edit')){
        let i;
        if(item.closest('.ctm_var_edit--cart-page')){ i = item.closest('.\\#cart-item') }
        else{ i = item.closest('.\\#product-card-min') }
        showEditVar(i);
    }

    if(item.closest('.ctm_var-edit--btn_cancel') || item.closest('.ctm_var_edit--popup_overlay')){
        let i = item.closest('.\\#product-card-min');
        hideEditVar(i);
    }

    if(item.closest('.\\#modal-popup-dialog')){
        setTimeout(() => {
            let i = item.closest('.\\#modal-popup-dialog');
            if(!i.attributes.open){ hideEditVar() }
        }, 500);   
    }
    
    if(item.closest('.ctm_var-edit--btn_apply')){
        let i;
        if(item.closest('.\\#cart-item')){ i = item.closest('.\\#cart-item') }
        else{ i = item.closest('.\\#product-card-min') }
        varChangeStart(i);
    }

    if(item.closest('.ctm_form_field--radio')){

        let grand_parent = item.closest('.\\#grid');
        let parent = item.closest('.ctm_form_field--radio');
        let i = parent.querySelector('input');
        
        // parent.classList.contains('ctm_form_field--radio_other') || 
        if( grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
            let otherRadio = i.value.toLowerCase() == 'other' || i.value.toLowerCase() == 'others' || i.value.toLowerCase().includes('other');
            let isTextThere = parent.querySelectorAll('.radio_other_field').length;

            let name = i.name;
            let placeholder = i.placeholder
            
            let html = document.createElement('input');
            html.className = 'radio_other_field';
            html.type = 'text';
            html.name = name;
            html.placeholder = placeholder;
            
            if(otherRadio && !isTextThere ){ parent.appendChild(html)}

        }else if ( !grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
            let isTextThere = grand_parent.querySelectorAll('.radio_other_field');
            isTextThere.forEach(e => { e.remove() });
        }
        
    }
    if (item.closest('.cus_data_var_id')) {
        // console.log('ran');
        let i = item.closest('.cus_data_var_id')
        updateCartWithId(i)
    }


    // Titan prd Add-on Events
    if(item.closest('.wheels_pipes_addon--item')){ addOnItemIsChecked(item) }
    if(item.closest('.wheels_pipes_addon--atc')){ addOnItemATCClick(item) }

    //Combo Unit Currently in-active
    if(item.closest('.combo_units--item')){
        let i = item.closest('.combo_units--item');
        let qty_input = item.closest('.\\#product-qty-selector').querySelector('input');
        qty_input.value = i.dataset.val;
        addOnItemQtyUpdate(item, parseInt(i.dataset.val));
    }

    if(item.closest('.quantity_selector_button')){
        let i = item.closest('.quantity_selector_button');
        let action = i.dataset.action;
        let input = item.closest('div').querySelector('input[name="quantity"]');

        if(action == '+'){ input.value = parseInt(input.value) + 1 }
        else if(action == '-'){  
            if(input.value != 1){ input.value = parseInt(input.value) - 1}
            else{ input.value = 1 }
        }

        input.dispatchEvent(new Event('change', { bubbles: true}));
    }
})     

document.addEventListener('change', (e) => {
    let item = e.target;

    if( item.closest('.\\#product-qty-selector-input[name="quantity"]')){ addOnItemQtyUpdate(item) }
    if( item.closest('product-variant-selector')){ updateAddOnitemVariant(item) }
})



// document.addEventListener('click', (e) => {
//     let item = e.target;
//     if(item.closest('.ctm_var_edit')){ let i; if(item.closest('.ctm_var_edit--cart-page')){i=item.closest('.\\#cart-item')}else{ i = item.closest('.\\#product-card-min')} showEditVar(i)}
//     if(item.closest('.ctm_var-edit--btn_cancel') || item.closest('.ctm_var_edit--popup_overlay')){let i = item.closest('.\\#product-card-min');hideEditVar(i)}
//     if(item.closest('.\\#modal-popup-dialog')){ setTimeout(() => { let i = item.closest('.\\#modal-popup-dialog'); if(!i.attributes.open){ hideEditVar()}}, 500);}
//     if(item.closest('.ctm_var-edit--btn_apply')){ let i;if(item.closest('.\\#cart-item')){ i = item.closest('.\\#cart-item')}else{ i = item.closest('.\\#product-card-min')}varChangeStart(i);}
//     if(item.closest('.ctm_form_field--radio')){
//         let grand_parent = item.closest('.\\#grid');let parent = item.closest('.ctm_form_field--radio');let i = parent.querySelector('input');
//         if( grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){
//             let otherRadio = i.value.toLowerCase() == 'other' || i.value.toLowerCase() == 'others' || i.value.toLowerCase().includes('other');
//             let isTextThere = parent.querySelectorAll('.radio_other_field').length;let name = i.name;let placeholder = i.placeholder;let html = document.createElement('input');
//             html.className = 'radio_other_field';html.type = 'text';html.name = name;html.placeholder = placeholder;if(otherRadio && !isTextThere ){ parent.appendChild(html)}
//         }else if ( !grand_parent.querySelector(`.ctm_form_field--radio_other input[type="checkbox"]`).checked ){let isTextThere = grand_parent.querySelectorAll('.radio_other_field');isTextThere.forEach(e => { e.remove() });}
//     }
//     if (item.closest('.cus_data_var_id')){let i = item.closest('.cus_data_var_id'); updateCartWithId(i);}
// })     